export enum CookieKey {
  INITIAL_REFERRING_PAGE = "initialReferringPage_v2",
  // Set server-side only (httpOnly), from the real Referer request header,
  // when a request carries a partner webhook_token. Used to warn on
  // suspicious partner attribution, not to gate it — see metadataForDonation.
  PARTNER_WEBHOOK_REFERRER = "partnerWebhookReferrer_v1",
  SIGNUP_SHARED_DONATION = "signupSharedDonation_v2",
  SIGNUP_INVITE = "signupInvite_v2",
  LANDING_PAGE = "landingPage_v2",
  SIGNUP_ADMIN_REQUEST_NONPROFIT_ID = "signupAdminRequestNonprofitId_v2",
  ADMIN_REFERRAL = "adminReferral_v2",

  SESSION_KEY = "koaSess_v2", // for koa-session
  /**
   * koa-session cookie name for the embedded (iframed) donate flow. Embed
   * sessions are transported in the EMBED_SESSION_HEADER, not a cookie
   * (third-party cookies are blocked in that context); this name only
   * exists so any cookie koa-session still writes on that branch (e.g.
   * clearing on removal) can never touch the main site's SESSION_KEY.
   */
  EMBED_SESSION_KEY = "koaSessEmbed_v1",
  SESSION_EXISTS = "sessionExists_v2",
  // Cookie which, if present, tells the client that we just created a new user
  // (social or email/password) and it should track the sign up
  TRACK_NEW_USER = "trackNewUser_v3",
  BACKEND_LOGIN_CSRF = "backendLoginCsrf_v2",

  // Key of cookie where testing ID for logged out users is stored; but user ID
  TESTING_ID_CACHE = "everydotorgAbtestId_v2",
  STABLE_ID = "everydotorgStableId",

  // used to tell the middleware about the user's status (emailVerified, deactivated, profileIncomplete) without having to make an API request
  USER_STATUS = "userStatus_v2",

  /**
   * Cookie used by the backend to send the CSRF cookie sent by the frontend
   * back after authentication has completed
   *
   * The frontend needs to access the cookie in order to validate that the state
   * hasnbeen tampered and it should take action based on authentication like
   * redirecting the user post-login, but post login, the page reloads so we send
   * the token back this way
   */
  RETURN_FRONTEND_AUTH_CSRF = "returnFrontendCsrfToken_v2",
  FORCE_LINK_IDP = "linkIdp_v2",
}
